
<template>
    <v-tooltip bottom nudge-bottom="10" class="secondary-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <router-link v-if="navClick" tag="span" :to="navTo">
                <v-btn v-bind="attrs" v-on="on" class="secondary-color app-bar-link" icon>
                    <v-icon v-if="isIcon">{{ iconString }}</v-icon>
                    <img v-else-if="isImage" :height="height" :width="width" :src="iconString" />
                </v-btn>
            </router-link>
            <v-btn v-else @click="emitClick" v-bind="attrs" v-on="on" class="secondary-color app-bar-link" icon>
                <v-icon v-if="isIcon">{{ iconString }}</v-icon>
                <img v-else-if="isImage" :height="height" :width="width" :src="iconString" />
            </v-btn>
        </template>
        <span>{{ toolTip }}</span>
    </v-tooltip>
</template>

<style scoped></style>

<script>
import * as IconTypes from '../../assets/Enums/IconTypeEnum'

export default {
    name: 'navigation-link',
    props: {
        navTo: {
            type: Object,
            default: () => {
                return {}
            },
        },
        height: {
            type: Number,
            default: 50
        },
        width: {
            type: Number,
            default: 50
        },
        iconString: {
            type: String,
            default: '',
        },
        toolTip: {
            type: String,
            default: '',
        },
        iconColorClass: {
            type: String,
            default: ''
        },
        iconType: {
            type: String,
            default: IconTypes.ICON,
        },
        navClick: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        emitClick() {
            this.$emit('click-event')
        },
    },
    computed: {
        isIcon() {
            return this.iconType === IconTypes.ICON
        },
        isImage() {
            return this.iconType === IconTypes.IMAGE
        },
        isSVG(){
            return this.iconType === IconTypes.SVG
        },
    },
}
</script>
